import React from "react";
import LiveBoards from "../../components/liveboardsview/LiveBoardsView";

function LiveBoardsViewPage() {
  return <LiveBoards />;
}

export default LiveBoardsViewPage;
